// extracted by mini-css-extract-plugin
module.exports = {"page":"Agenda_page__x4su_","text":"Agenda_text__nT4UP","link":"Agenda_link__Hx3le"};